import React, {
  FC,
  ReactElement,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";

//@ts-ignore
import { LocalizationContext } from "react-localize";
import "./styles.css";
import "./ConfirmationModal/modal.css";
import "react-datepicker/dist/react-datepicker.css";

import { ScreenType } from "Constants";

import { HopperHomeReducer } from "./HopperHomeReducer";
import { Actions, InitState, PageErrorType } from "./types";
import icon from "../../../Assests/Img/MVC_Icon_CalendarClock_Stone 1.png";
import reservationService from "Services/reservation.service";
import { HopperAvailabiltyInfo, OwnerInfoRecord } from "Interfaces/OwnerInfo";
import ReservationService from "Services/reservation.service";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MvHopperConfirmationModal } from "./ConfirmationModal/HopperConfirmationModal";
import {
  MVC_TYPE,
  MVC_VSE_DOMAIN,
  VCAP_DOMAIN,
  VSE_TYPE,
  formatDate,
  formatNumber,
  getDomainName,
} from "./constant";
import { HopperPointsSummary } from "./PointsSummaryModal/HopperPointsSummary";
import ToolTip from "Generic/ToolTip";
import { Tip } from "Interfaces/TipInterface";
import {
  HOPPER_INELIGIBLE_TYPES_APV1,
  HOPPER_INELIGIBLE_TYPES_APV2,
  HOPPER_INELIGIBLE_TYPES_SC,
  HOPPER_MFEES_REDIRECT_URL,
  HOPPER_VSE_REDIRECT_URL,
} from "cfg";
import mvclogo from "./static/images/mvclogo.png";
import { logAnalyticData, logLinkInfoAnalyticData } from "Utils/analytics";
import { InEligibleModal } from "./InEligibleModal/InEligibleModal";
import TermsAndConditions from "./TermsAndCondition/TermsAndConditions";
import { isBoolean } from "lodash";
import { isVOAReadOnly } from "Utils";


type Props = {
  vcapctaType: string;
  vcapmpmId: string;
  token: string;
  lang: string;
  setScreenType(screenType: ScreenType): void;
};

const HopperHome: FC<any> = (props: Props): ReactElement => {
  const [pointsBalance, setpointsBalance] = useState("");
  const [reducerState, dispatch] = useReducer(HopperHomeReducer, InitState);
  const [showHotel, setshowHotel] = useState(false);
  const [showInEligibleModal, setshowInEligibleModal] = useState(false);
  const [showPointsSummary, setshowPointsSummary] = useState(false);
  const [ownerType, setOwnerType] = useState("points");
  const [isRestrictHopperAccess, setIsRestrictHopperAccess] = useState(false);
  const { localize } = useContext(LocalizationContext);
  const queryString: string = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let mpmId: string = String(urlParams.get("mpmId"));
  let ctaType: string =
    String(urlParams.get("ctaType")) || String(urlParams.get("intMode"));
  /** DIGMVO-163 */
  const vcapmpmid = props.vcapmpmId;
  const vcapclubtype = props.vcapctaType;
  const ssoTokenForReact: any = sessionStorage.getItem("EXP_API_TKN");
  // AM-8825
  const langCookieRow = document.cookie
    .split('; ')
    .find(row => row.startsWith('langPref='));
  const langCookie = langCookieRow ? langCookieRow.split('=')[1] : 'en';
  if (mpmId === "null" || undefined || "") {
    mpmId = vcapmpmid;
  }
  if (ctaType === "null" || undefined || "") {
    ctaType = vcapclubtype;
  }

  const hopperBaseAvailabilityUrl = String(
    localize("static.content.search-availability-cta-link")
  );
  const hopperBaseSearchUrl = String(
    localize("static.content.search-hotels-cta-link")
  );

  const baseParams: any = {
    ownerId: mpmId,
    clubCode: ctaType,
    token: ssoTokenForReact,
    langPref: langCookie
  };
  const HOPPER_BASE_AVAILABILITY_PARAMS_URL = hopperBaseAvailabilityUrl.replace(
    /\{(.*?)\}/g,
    (match, key) => baseParams[key] || match
  );
  const HOPPER_BASE_SEARCH_PARAMS_URL = hopperBaseSearchUrl.replace(
    /\{(.*?)\}/g,
    (match, key) => baseParams[key] || match
  );

  const [hopperLandingParam, sethopperLandingParam] = useState("");
  const reservationService: ReservationService = new ReservationService();
  const hopper_destination: any = sessionStorage.getItem("hopperTypesContent");
  const hopperDestArr = JSON.parse(hopper_destination);
  const hopperWhyBook: any = sessionStorage.getItem("hopperWhyBookContent");
  const hopperWhyBookObj = JSON.parse(hopperWhyBook);
  const hopperDatePicker: any = sessionStorage.getItem("hopperDatePicker");
  const hopperDatePickerObj = JSON.parse(hopperDatePicker);
  const incrementerValue = String(
    localize("static.content.points-calendar-date-plus-numeric")
  );
  const maxDateValue = String(
    localize("static.content.points-calendar-max-date-numeric")
  );
  const hopperDateIncrementer = parseInt(incrementerValue);
  const hopperMaxDateValue = parseInt(maxDateValue);
  const [selectedCurrentDate, setselectedCurrentDate] = useState(new Date());
  const [currentDateFormatted, setcurrentDateFormatted] = useState("");
  const [rangeStart, setRangeStart] = useState(new Date());
  const [potentialBalance, setpotentialBalance] = useState("");
  const [currentBalance, setcurrentBalance] = useState("");
  const [eligibleUsage, seteligibleUsage] = useState([]);
  const [ownerAlertFlag, setownerAlertFlag] = useState(false);
  const [ownerAlertText, setownerAlertText] = useState("");
  const [ownerApiFailure, setownerApiFailure] = useState(false);

  const defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);
  const [rangeEnd, setRangeEnd] = useState(defaultEndDate);
  const today = new Date();
  const defaultDate = new Date();
  const maxDate = new Date();

  const selectDateHandler = (d: React.SetStateAction<Date>) => {
    setselectedCurrentDate(d);
  };
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedMaxDate, setselectedMaxDate] = useState(maxDate);
  const [defaultCalDate, setdefaultCalDate] = useState(defaultDate);
  const [hideManageMyPoints, sethidemanageMyPoints] = useState(false);
  const [mangageMyPoints, setmangageMyPoints] = useState("");
  const tooltip: [Tip] = [
    {
      label: "",
      desc: "Reservations may be confirmed as early as 350 days prior to the arrival date and no later than 4 days prior to hotel arrival date.",
    },
  ];

  /** Adobe Analytics */
  useEffect(() => {
    //Hotel Landing page page load
    logAnalyticData(
      {
        event: "hopperHotelLanding",
        siteSection: "Points",
        pageName: "Hotel Landing Page - Hopper",
        website: "",
      },
      {
        ownerActivity: "Hopper",
        benefitLevel: "",
        ownerType: "",
        errorMessage: "",
      }
    );
  }, []);
  /** DIGMVO-172 */
  useEffect(() => {
    const baseUrl = window.location.origin;
    const hostname = window.location.hostname;
    const mainDomain = getDomainName(hostname);
    if (mainDomain === "marriottvacationclub.com") {
      sethidemanageMyPoints(false);
      setmangageMyPoints(baseUrl + "/timeshare/mvco/getProductSummary");
    } else if (mainDomain === "vacationclubap.com") {
      sethidemanageMyPoints(true);
    } else {
      sethidemanageMyPoints(false);
    }
  }, []);
  useEffect(() => {
    if (!Number.isNaN(hopperDateIncrementer)) {
      today.setDate(today.getDate() + hopperDateIncrementer);
      defaultDate.setDate(defaultDate.getDate() + hopperDateIncrementer);
      setSelectedDate(today);
      setdefaultCalDate(defaultDate);
      setselectedCurrentDate(today);
    } else {
      today.setDate(today.getDate());
      setSelectedDate(today);
      setselectedCurrentDate(today);
    }
  }, [hopperDateIncrementer]);

  useEffect(() => {
    setSelectedDate(selectedCurrentDate);
    setcurrentDateFormatted(formatDate(selectedCurrentDate));
  }, [selectedCurrentDate]);

  useEffect(() => {
    if (!Number.isNaN(hopperMaxDateValue)) {
      maxDate.setDate(maxDate.getDate() + hopperMaxDateValue);
      setselectedMaxDate(maxDate);
    }
  }, [hopperMaxDateValue]);

  // const selectStartDate = (d: React.SetStateAction<Date>) => {
  //   setRangeStart(d)
  // }

  // const selectEndDate = (d: React.SetStateAction<Date>) => {
  //   setRangeEnd(d)
  // }

  useEffect(() => {
    if (currentDateFormatted !== "" || undefined) {
      // QA-49046, DIGMVO-628
      if (new Date(currentDateFormatted) > new Date()) {
      let fetchOwnerInfo: [Promise<HopperAvailabiltyInfo>] = [
        reservationService.getHopperAvailability(
          currentDateFormatted,
          ctaType,
          "HOPPER",
          mpmId
        ),
      ];
      dispatch({
        type: Actions.SETDATA,
        payload: { ownerInfo: "loading" },
      });
      Promise.all(fetchOwnerInfo)
        .then((result: any[]) => {
          const ownerInfo: HopperAvailabiltyInfo = result[0] ? result[0] : [];
          dispatch({
            type: Actions.SETDATA,
            payload: { ownerInfo: ownerInfo },
          });
        })
        .catch((error: any) => {
          dispatch({
            type: Actions.SETDATA,
            payload: { ownerInfo: "error" },
          });
          dispatch({
            type: Actions.ERROR,
            payload: { code: error.code },
          });
        });
      }
    }
  }, [currentDateFormatted]);

  useEffect(() => {
    if (reducerState.ownerInfo == "loading") {
      setpotentialBalance("");
      setcurrentBalance("");
    }
    if(isBoolean(reducerState.ownerInfo.disableVoaBookCapability) || isBoolean(reducerState.ownerInfo.restrictReservationFromWebServices)){      
      setIsRestrictHopperAccess(!!reducerState.ownerInfo.disableVoaBookCapability || !!reducerState.ownerInfo.restrictReservationFromWebServices);
    }
    if (reducerState.ownerInfo !== "loading") {
      const pointsBalanceData = reducerState.ownerInfo.pointsBalance;
      const currentBalanceData = reducerState.ownerInfo.currentPointsBalance;
      if (
        reducerState &&
        pointsBalanceData !== "" &&
        pointsBalanceData !== undefined &&
        pointsBalanceData !== null
      ) {
        const formattedPotentialBalance = formatNumber(
          reducerState.ownerInfo.pointsBalance
        );
        setpotentialBalance(formattedPotentialBalance);
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      } else {
        setpotentialBalance("Not Available");
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      }
      if (
        reducerState &&
        currentBalanceData !== "" &&
        currentBalanceData !== undefined &&
        currentBalanceData !== null
      ) {
        const formattedCurrentBalance = formatNumber(
          reducerState.ownerInfo.currentPointsBalance
        );
        setcurrentBalance(formattedCurrentBalance);
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      } else {
        setcurrentBalance("Not Available");
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      }
      const ownerAlertStatus = reducerState.ownerInfo.ownerStatus;
      const ownerAlertMessage = reducerState.ownerInfo.ownerAlert;
      if (ownerAlertStatus === "ALERT") {
        setownerAlertFlag(true);
        setownerAlertText(
          localize("static.content.omvc-outstanding-fees-message")
        );
      }
    }
    if (
      reducerState.ownerInfo == "error" &&
      reducerState.ownerInfoErrorCode === 404
    ) {
      setpotentialBalance("0");
      setcurrentBalance("0");
      setownerApiFailure(false);
    } else if (
      reducerState.ownerInfo == "error" &&
      reducerState.ownerInfoErrorCode !== 404
    ) {
      setpotentialBalance("Not Available");
      setcurrentBalance("Not Available");
      setownerApiFailure(true);
    }
  }, [reducerState]);

  /** DIGMVO-397 */
  useEffect(() => {
    console.log("digmvo-397 trigerred");
    if (
      (ctaType === "MVC" || ctaType === "VOA") &&
      reducerState.ownerInfo == "error" &&
      reducerState.ownerInfoErrorCode === 422
    ) {
      console.log("data", reducerState.ownerInfoErrorCode);
      const dataOwner = document.getElementsByClassName("pwasReactMainDiv");
      const dataOwnerType = dataOwner[0].getAttribute("data-ownertype");
      console.log("dataOwnerType", dataOwnerType);
      if (dataOwnerType === "weeks") {
        setOwnerType("weeks");
        setshowInEligibleModal(true);
        const allBtn = document.querySelectorAll("button");
        allBtn.forEach((button) => {
          if (button.id !== "ineligible-previous-btn") {
            button.disabled = true;
          }
        });
        setshowInEligibleModal(true);
      }
    }
  }, [reducerState]);

  /** DIGMVO-383 */
  useEffect(() => {
    if (
      ctaType === "VCAP" &&
      reducerState.ownerInfo == "error" &&
      reducerState.ownerInfoErrorCode === 404
    ) {
      console.log(
        "Ineligible Data",
        HOPPER_INELIGIBLE_TYPES_SC,
        HOPPER_INELIGIBLE_TYPES_APV1,
        HOPPER_INELIGIBLE_TYPES_APV2
      );
      const contractVal = sessionStorage.getItem("VCAP_CONTRACT_TYPES");
      const contractArr =
        (contractVal && contractVal.replace(/[[\]]/g, "").split(",")) || [];
      const contractLength = contractArr && contractArr.length;
      console.log("contractVal", contractVal, contractLength, contractArr);
      if (
        (contractArr &&
          contractLength === 1 &&
          contractVal === HOPPER_INELIGIBLE_TYPES_SC) ||
        HOPPER_INELIGIBLE_TYPES_APV1 ||
        HOPPER_INELIGIBLE_TYPES_APV2
      ) {
        const allBtn = document.querySelectorAll("button");
        allBtn.forEach((button) => {
          if (button.id !== "ineligible-previous-btn") {
            button.disabled = true;
          }
        });
        setshowInEligibleModal(true);
      } else {
        const excludedElements = [
          HOPPER_INELIGIBLE_TYPES_SC,
          HOPPER_INELIGIBLE_TYPES_APV1,
          HOPPER_INELIGIBLE_TYPES_APV2,
        ];
        const otherElements = contractArr.filter(
          (element) => !excludedElements.includes(element)
        );
        console.log(otherElements.length);
        if (otherElements.length <= 0) {
          const allBtn = document.querySelectorAll("button");
          allBtn.forEach((button) => {
            if (button.id !== "ineligible-previous-btn") {
              button.disabled = true;
            }
          });
          setshowInEligibleModal(true);
        }
      }
      setpotentialBalance("0");
      setcurrentBalance("0");
      setownerApiFailure(false);
    }
  }, [reducerState]);

  useEffect(() => {
    if (reducerState.ownerInfo == "loading") {
      setpotentialBalance("");
      setcurrentBalance("");
    }
    if (reducerState.ownerInfo !== "loading") {
      const pointsBalanceData = reducerState.ownerInfo.pointsBalance;
      const currentBalanceData = reducerState.ownerInfo.currentPointsBalance;
      if (
        reducerState &&
        pointsBalanceData !== "" &&
        pointsBalanceData !== undefined &&
        pointsBalanceData !== null
      ) {
        const formattedPotentialBalance = formatNumber(
          reducerState.ownerInfo.pointsBalance
        );
        setpotentialBalance(formattedPotentialBalance);
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      } else {
        setpotentialBalance("Not Available");
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      }
      if (
        reducerState &&
        currentBalanceData !== "" &&
        currentBalanceData !== undefined &&
        currentBalanceData !== null
      ) {
        const formattedCurrentBalance = formatNumber(
          reducerState.ownerInfo.currentPointsBalance
        );
        setcurrentBalance(formattedCurrentBalance);
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      } else {
        setcurrentBalance("Not Available");
        seteligibleUsage(reducerState.ownerInfo.eligibleUsage);
      }
      const ownerAlertStatus = reducerState.ownerInfo.ownerStatus;
      const ownerAlertMessage = reducerState.ownerInfo.ownerAlert;
      if (ownerAlertStatus === "ALERT") {
        setownerAlertFlag(true);
        setownerAlertText(
          localize("static.content.omvc-outstanding-fees-message")
        );
      }
    }
    if (
      reducerState.ownerInfo == "error" &&
      reducerState.ownerInfoErrorCode === 404
    ) {
      setpotentialBalance("0");
      setcurrentBalance("0");
      setownerApiFailure(false);
    } else if (
      reducerState.ownerInfo == "error" &&
      reducerState.ownerInfoErrorCode !== 404
    ) {
      setpotentialBalance("Not Available");
      setcurrentBalance("Not Available");
      setownerApiFailure(true);
    }
  }, [reducerState]);

  const modalTrigger = (screen: any, val: any) => {
    sethopperLandingParam(screen);
    setshowHotel(val);
    if (val == true) {
      logAnalyticData(
        {
          event: "hopperDeparturePopUp",
          siteSection: "Points",
          pageName: "Departure Pop up - Hopper",
          website: "",
        },
        {
          ownerActivity: "Hopper",
          benefitLevel: "",
          ownerType: "",
          errorMessage: "",
        }
      );
    }
  };

  const modalTriggerPointsSummary = (val: any) => {
    setshowPointsSummary(val);
  };

  const searchHotels = (data: any) => {
    // Adobe Analytics
    logLinkInfoAnalyticData({
      event: "hopperHotelCta",
      pageName: "Hotel Landing Page - Hopper",
      linkClickPage: "Hopper External Booking Page",
      linkClickRegion: "NATO",
      linkName: "EXPLORE HOTELS",
    });
    const pointsBalance: any = reducerState;
    setpointsBalance(pointsBalance);
    modalTrigger(data, true);
  };
  const searchDate = (data: any) => {
    //const pointsBalance: string = reducerState.ownerInfo.ownerBenefitLevels[0].points;
    // Adobe Analytics
    logLinkInfoAnalyticData({
      event: "hopperHotelCta",
      pageName: "Hotel Landing Page - Hopper",
      linkClickPage: "Hopper External Booking Page",
      linkClickRegion: "NATO",
      linkName: "SEARCH AVAILABILITY",
    });

    setpointsBalance(pointsBalance);
    modalTrigger("searchdate", true);
  };
  // const handlePointsSummary = (data: any) => {
  //   modalTriggerPointsSummary(true);
  // };

  const toggleModal = () => {
    setshowHotel(false);
  };
  const togglePointsSummaryModal = () => {
    setshowPointsSummary(false);
  };
  const toggleInEligibleModal = () => {
    setshowInEligibleModal(false);
  };
  const confirm = (hopperLandingParam: string) => {
    if(hopperLandingParam.startsWith('destinationClick##')){
      let destinationQueryParam = hopperLandingParam.replace('destinationClick##','');
       console.log('HOPPER_DESTINATION_PARAMS_URL', destinationQueryParam);
    window.open(destinationQueryParam, "_blank");
    setshowHotel(false);
    }
    else{
    let hopperFinalUrl;
    const formattedCurrentDate = formatDate(selectedCurrentDate)
      .split(`-`)
      .join(``);
    if (hopperLandingParam === "searchhotel") {
      console.log("hopper url from search-hotels-cta-link");
      hopperFinalUrl = HOPPER_BASE_SEARCH_PARAMS_URL;
    } else if (hopperLandingParam === "searchdate") {
      console.log("hopper url from search-availability-cta-link");
      hopperFinalUrl = HOPPER_BASE_AVAILABILITY_PARAMS_URL.replace(
        "{YYYYMMDD}",
        formattedCurrentDate
      );
    }

    console.log("HOPPER_FINAL_URL", hopperFinalUrl);
    window.open(hopperFinalUrl, "_blank");
    setshowHotel(false);
    // Adobe Analytics
    logLinkInfoAnalyticData({
      event: "hopperCancelDepartureYes",
      pageName: "Hotel Landing Page - Hopper",
      linkClickPage: hopperFinalUrl,
      linkClickRegion: "NATO",
      linkName: "Hopper External Booking Page",
    });
    }
  };

  const mangageMyPointsClick = () => {
    // Adobe Analytics
    logLinkInfoAnalyticData({
      event: "hopperHotelCta",
      pageName: "Hotel Landing Page - Hopper",
      linkClickPage: "Hopper External Booking Page",
      linkClickRegion: "NATO",
      linkName: "Manage My Points",
    });
  };

  /**DIGMVO-170 */
  /** Display Points Summary Popup */
  const handlePointsSummaryClick = (event: { target: { tagName: string } }) => {
    if (event.target.tagName === "A") {
      // Adobe Analytics
      logLinkInfoAnalyticData({
        event: "hopperHotelCta",
        pageName: "Hotel Landing Page - Hopper",
        linkClickPage: "Hopper External Booking Page",
        linkClickRegion: "NATO",
        linkName: "See Points Summary",
      });
      modalTriggerPointsSummary(true);
    }
  };
  /**DIGMVO-189 */
  /** Delinquent pay fees click */
  const handlePayMfeesClick = (event: { target: { tagName: string } }) => {
    if (event.target.tagName === "A") {
      const baseUrl = window.location.origin;
      const hostname = window.location.hostname;
      const mainDomain = getDomainName(hostname);
      if (mainDomain === MVC_VSE_DOMAIN && ctaType === MVC_TYPE) {
        window.open(
          HOPPER_MFEES_REDIRECT_URL +
            localize("static.content.omvc-pay-fees-now-link")
        );
      } else if (mainDomain === VCAP_DOMAIN) {
        window.open(
          HOPPER_MFEES_REDIRECT_URL +
            localize("static.content.vcap-pay-fees-now-link")
        );
      } else if (mainDomain === MVC_VSE_DOMAIN && ctaType === VSE_TYPE) {
        window.open(
          HOPPER_VSE_REDIRECT_URL +
            localize("static.content.omvc-pay-fees-now-link")
        );
      }
    }
  };
  const abort = () => {
    // Adobe Analytics
    logLinkInfoAnalyticData({
      event: "hopperCancelDepartureNo",
      pageName: "Hotel Landing Page - Hopper",
      linkClickPage: "Hopper External Booking Page",
      linkClickRegion: "NATO",
      linkName: "Hopper External Booking Page",
    });
    setshowHotel(false);
  };
  const onChange = () => {};
  /** DIGMVO-186 Destination click Hotel Landing */
  const destinationClickEvent = (url: any) => {
    const destinationBaseUrl = url;
    const HOPPER_DESTINATION_PARAMS_URL = destinationBaseUrl.replace(/\{(.*?)\}/g, (match: any, key: string | number) => baseParams[key] || match);
    sethopperLandingParam("destinationClick##"+HOPPER_DESTINATION_PARAMS_URL);
    setshowHotel(true);
    // Adobe Analytics
    logLinkInfoAnalyticData({
      event: "hopperHotelCta",
      pageName: "Hotel Landing Page - Hopper",
      linkClickPage: "Hopper External Booking Page",
      linkClickRegion: "NATO",
      linkName: "Destinations",
    });
  };

  return (
    <>
      <MvHopperConfirmationModal
        header={localize("static.content.third-party-modal-title")}
        description={localize("static.content.third-party-modal-description")}
        message=""
        abortLabel={localize("static.content.no-button-label")}
        confirmLabel={localize("static.content.yes-button-label")}
        closeiconnato={ctaType === ("MVC" || "VSE") ? true : false}
        openModal={showHotel}
        toggleModal={() => toggleModal()}
        confirm={() => confirm(hopperLandingParam)}
        abort={() => abort()}
      />
      {/* DIGMVO-383 & 397*/}
      <InEligibleModal
        ineligibleheader={localize(
          "static.content.ineligible-to-book-modal-header"
        )}
        ineligibledescription={
          ownerType === "weeks"
            ? localize(
                "static.content.weeks-ineligible-to-book-modal-description"
              )
            : localize("static.content.ineligible-to-book-modal-description")
        }
        ineligiblebtn={localize(
          "static.content.return-to-previous-screen-button"
        )}
        closeiconnato={ctaType === ("MVC" || "VSE") ? true : false}
        openModal={showInEligibleModal}
        toggleModal={() => toggleInEligibleModal()}
        confirm={() => confirm(hopperLandingParam)}
        abort={() => abort()}
      />
      <HopperPointsSummary
        header={localize("static.content.points-summary-modal-header")}
        description={localize(
          "static.content.points-summary-modal-description"
        )}
        pointsHeading={localize("static.content.modal-points-section-title")}
        pointsSummary={localize(
          "static.content.modal-points-section-description"
        )}
        contractNumber={localize(
          "static.content.points-summary-table-contract-number-label"
        )}
        pointsAvailable={localize(
          "static.content.points-summary-table-points-available-label"
        )}
        usageType={localize(
          "static.content.points-summary-table-usage-type-label"
        )}
        dates={localize("static.content.points-summary-table-dates-label")}
        closeiconnato={ctaType === ("MVC" || "VSE") ? true : false}
        eligibleUsage={eligibleUsage}
        openModal={showPointsSummary}
        toggleModal={() => togglePointsSummaryModal()}
        confirm={() => confirm(hopperLandingParam)}
        abort={() => abort()}
      />
      <div className="hopper-home">
        <div className="hopper-left-section">
          <div className="hopper-mobile-logo">
            <img src={mvclogo} alt="mvc" />
          </div>
          <p className="left-heading-one"> Hotels </p>
          <p className="left-heading-two">
            <span
              dangerouslySetInnerHTML={{
                __html: localize("static.content.omvc-hotels-description"),
              }}
            ></span>
          </p>
          <div></div>
        </div>
        <div className="hopper-right-section">
          <p className="right-heading-one">
            {localize("static.content.omvc-points-balance-header")}
          </p>
          <p className="right-heading-two">
            <span
              dangerouslySetInnerHTML={{
                __html: localize(
                  "static.content.omvc-search-availability-description"
                ),
              }}
            ></span>
          </p>
          <div className="right-date-section">
            {Object.keys(hopperDatePickerObj || {}).map((key) => (
              <>
                <img key={key} src={hopperDatePickerObj[key]} alt={key} />
              </>
            ))}
            <div className="right-date-text-section">
              <DatePicker
                dateFormat="MMMM dd, yyyy"
                selected={selectedDate}
                onChange={selectDateHandler}
                minDate={defaultCalDate}
                maxDate={selectedMaxDate}
                className="hopper-datepicker"
                showMonthDropdown
                showYearDropdown
              />
            </div>
            <ToolTip
              useRefToPosition={false}
              tabIndex={-1}
              tip={tooltip}
              id={"1"}
            >
              <span className="hopper-datepicker-info">
                <i className="fa fa-info"></i>
              </span>
            </ToolTip>
          </div>
          <div className="right-col-current-balance-section">
            <p className="right-col-current-balance-text">
              {localize("static.content.current-balance-label")}
            </p>
            <p
              className={
                "right-col-current-balance-val" +
                " " +
                (reducerState.ownerInfo == "loading" ? "loading" : "")
              }
            >
              {currentBalance}
            </p>
          </div>
          <div className="right-col-potential-balance-section">
            <p className="right-col-potential-balance-text">
              {localize("static.content.potential-balance-label")}
            </p>
            <p
              className={
                "right-col-current-balance-val" +
                " " +
                (reducerState.ownerInfo == "loading" ? "loading" : "")
              }
            >
              {potentialBalance}
            </p>
          </div>
          {ownerAlertFlag && (
            <>
              <div className="right-col-ineligible-alert-section">
                <div className="ineligible-alert-left">
                  <i className="fa fa-exclamation-triangle"></i>
                </div>
                <div className="ineligible-alert-right">
                  <p className="ineligible-alert-text">
                    <span
                      onClick={handlePayMfeesClick}
                      dangerouslySetInnerHTML={{
                        __html: localize(
                          "static.content.omvc-outstanding-fees-message"
                        ),
                      }}
                    ></span>
                  </p>
                </div>
              </div>
            </>
          )}
          {ownerApiFailure && (
            <>
              <div className="right-col-ineligible-alert-section">
                <div className="ineligible-alert-left">
                  <i className="fa fa-exclamation-triangle"></i>
                </div>
                <div className="ineligible-alert-right">
                  <p className="ineligible-alert-text">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: localize(
                          "static.content.points-balance-technical-error"
                        ),
                      }}
                    ></span>
                  </p>
                </div>
              </div>
            </>
          )}
          {/* DIGMVO-630, QA-48161 disabled '|| reducerState.ownerInfo.restrictReservationFromWebServices' conidtioned added for three cta's present on the screen */}          
          {reducerState.ownerInfo.restrictReservationFromWebServices && (
            <>
              <div className="right-col-ineligible-alert-section">
                <div className="ineligible-alert-left">
                  <i className="fa fa-exclamation-triangle"></i>
                </div>
                <div className="ineligible-alert-right">
                  <p className="ineligible-alert-text">
                    <span
                      dangerouslySetInnerHTML={{
                        __html:localize("static.content.trust-access-error"),
                      }}
                    ></span>
                  </p>
                </div>
              </div>
            </>
          )}
          <p className="right-heading-three">
            {/* Below is Typescript error, can be ignored */}
            <span
              onClick={handlePointsSummaryClick}
              dangerouslySetInnerHTML={{
                __html: localize("static.content.omvc-points-disclaimer"),
              }}
            ></span>
          </p>
          <button
            className="search-date-btn"
            onClick={() => searchDate("searchdate")}
            disabled={isRestrictHopperAccess || isVOAReadOnly()}
          >
            {localize("static.content.search-availability-cta-label")}
          </button>
          {hideManageMyPoints ? (
            ""
          ) : (
            <a
              href={mangageMyPoints}
              onClick={mangageMyPointsClick}
              className="right-manage-link"
            >
              {localize("static.content.manage-points-label")}
            </a>
          )}
        </div>
      </div>
      <div className="hopper-destination-section">
        <p className="popular-destination-text">
          {localize("static.content.popular-destinations-header")}
        </p>
        {/* DIGMVO-166  */}
        {/* Destination sorting is based on the order value from jahia */}
        {hopperDestArr !== null &&
          hopperDestArr
            .sort((a: any, b: any) => a.order - b.order)
            .map(
              (obj: {
                description: string;
                image: any;
                header: any;
                url: any;
              }) => (
                <>
                  <div
                    className={`destination-container ${isRestrictHopperAccess ? 'disabled' : ''}`}
                    onClick={() => destinationClickEvent(obj.url)}                    
                  >
                    <div className="popular-destination-main-container">
                      <div className="popular-destination-img-container">
                        <img src={obj.image} alt="" />
                      </div>
                      <div className="popular-destination-text-main-container">
                        <div className="popular-destination-text-container">
                          {obj.header}
                        </div>
                        <div className="popular-destination-small-text-container">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: obj.description,
                            }}
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )
            )}
      </div>
      <div className="hopper-why-book-club-section">
        <div className="why-club-section-left">
          <p className="why-club-section-left-text-one">
            {localize("static.content.why-book-header")}
          </p>
          <p
            className="why-club-section-left-text-two"
            dangerouslySetInnerHTML={{
              __html: localize("static.content.why-book-description"),
            }}
          ></p>
          <button
            className="why-club-section-left-button"
            onClick={() => searchHotels("searchhotel")}
            disabled={isRestrictHopperAccess}
          >
            {localize("static.content.search-hotels-cta-label")}
          </button>
        </div>
        <div className="why-club-section-right">
          {Object.keys(hopperWhyBookObj || {}).map((key) => (
            <>
              <img key={key} src={hopperWhyBookObj[key]} alt={key} />
            </>
          ))}
        </div>
      </div>
      <TermsAndConditions />
    </>
  );
};

HopperHome.contextTypes = LocalizationContext;
export { HopperHome };
